<template>
  <nav class="mobile-bottom-nav" aria-label="手机端主导航">
    <button
      v-for="item in items"
      :key="item.route"
      type="button"
      :class="{ active: isActive(item.route) }"
      @click="navigate(item)"
    >
      <IconSymbol :name="item.icon" />
      <span>{{ item.title }}</span>
    </button>
  </nav>
</template>

<script>
import IconSymbol from './IconSymbol.vue'
import { isLoggedIn, requireLogin } from '../utils/auth'
import { isWechatBrowser } from '../utils/wechatOauth'

export default {
  name: 'MobileBottomNav',
  components: { IconSymbol },
  data() {
    return {
      items: [
        { title: '首页', route: '/', icon: 'home' },
        { title: '订单', route: '/workspace/orders', icon: 'orders', auth: true },
        { title: '我的', route: '/workspace/profile', icon: 'user', auth: true }
      ]
    }
  },
  methods: {
    isActive(route) {
      if (route === '/') return this.$route.path === '/'
      if (route === '/workspace/profile') return this.$route.path.startsWith(route)
      return this.$route.path === route
    },
    navigate(item) {
      const go = () => {
        if (this.$route.path !== item.route) this.$router.push(item.route)
      }
      if (!item.auth || isLoggedIn() || isWechatBrowser()) {
        go()
        return
      }
      requireLogin(go)
    }
  }
}
</script>

<style scoped>
.mobile-bottom-nav { display: none; }

@media (max-width: 900px) {
  .mobile-bottom-nav {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 58;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    min-height: calc(64px + env(safe-area-inset-bottom));
    padding: 7px 18px calc(6px + env(safe-area-inset-bottom));
    border-top: 1px solid rgba(211, 224, 239, .9);
    background: rgba(255, 255, 255, .96);
    backdrop-filter: blur(16px);
  }

  .mobile-bottom-nav button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 0;
    padding: 2px 8px;
    border: 0;
    border-radius: 14px;
    color: #8290a5;
    background: transparent;
    font-size: 11px;
    font-weight: 700;
  }

  .mobile-bottom-nav button.active {
    color: var(--brand-blue);
    background: linear-gradient(145deg, #eff6ff, #f5faff);
  }

  .mobile-bottom-nav .icon-symbol { width: 22px; height: 22px; }
}
</style>
